import React from 'react';
import PropTypes from 'prop-types';

const Section = ({ children }) => {
  return (
    <section className="section">
      <div className="limit padded" style={{ position: 'relative' }}>
        {children}
      </div>
    </section>
  );
};

Section.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.array.isRequired])
};

export default Section;



// WEBPACK FOOTER //
// ./src/common/jsx/elements/section/Section.js